import React, { useEffect, useState } from "react";
import Banner from "../../components/Banner";
import { useNavigate } from "react-router-dom";
import axios from "../../utils/request";
import { en, ch } from "../../utils/content";
import "./index.css";

const CasePage = () => {
  const [cases, setCases] = useState<any>([]);
  const chunkArray = (array: any, len: number) => {
    let result = [];
    for (let i = 0; i < array.length; i += len) {
      result.push(array.slice(i, i + len));
    }
    return result;
  };
  useEffect(() => {
    const initData = async () => {
      const res: any = await axios.get("/index/cases");
      if (res.code === 200) {
        setCases(chunkArray(res.data.data || [], 3));
      }
    };
    initData();
  }, []);
  const lang = sessionStorage.getItem("lang") || "ch";
  const TXT_INFO = lang === "en" ? en : ch;
  const navigate = useNavigate();
  return (
    <div className="case-box">
      <Banner />
      <div className="case">
        <div className="c-container">
          {cases?.map((item: any) => {
            return (
              <div className="c-c-ul">
                {item?.map((c: any) => {
                  const liStyle = {
                    backgroundImage: `url(${c.img})`,
                  };
                  return (
                    <div
                      className="c-c-li"
                      style={liStyle}
                      onClick={() => {
                        navigate("/detail", {
                          state: {
                            url: "/index/cases/detail",
                            id: c?.id,
                          },
                        });
                      }}
                    >
                      <div className="c-c-li-bottom">
                        <div className="c-c-li-b-title">{c?.title}</div>
                        <div className="c-c-li-b-btn">{TXT_INFO.learnMore}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CasePage;
